import type { Address } from "viem"
import { getAddress } from "viem"

export type CreatePairTransactionResult = {
  transaction: {
    logs: Array<ResultLog>
  }
}

type ResultLog = {
  topics: Array<string>
}

const TEST_LOG_TOPICS = [
  "0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef",
  "0x000000000000000000000000a740522ecaff98d1f2ebb29d5caa19fd4cf5d92f",
  "0x0000000000000000000000009b88323e04bb5a07104da4d72c2270c9db9e2e8f",
]

export const extractPairAddressFromResultLogs = (result: CreatePairTransactionResult): Address | undefined => {
  const logs = Array.isArray(result.transaction.logs) ? result.transaction.logs : []
  const pairCreatedLog = logs.find((log) =>
    log.topics.includes("0xddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef"),
  )

  const found = pairCreatedLog?.topics[2] ?? undefined
  if (found) {
    return processLogTopicAddress(found)
  }
  return undefined
}

export const processLogTopicAddress = (address: string): Address | undefined => {
  if (!address.startsWith("0x") || address.length !== 66) {
    return undefined
  }
  // Extract the last 40 hex characters (the address portion) from the padded log topic
  const addressHex = `0x${address.slice(-40)}`
  return getAddress(addressHex)
}
